/**
 * Global /scoring page. EvaluationPickerSheet → on pick → ScoringWorkspace
 * (the E2/E3/E4/E5 component) inside the shared module-page chrome. URL
 * preserves the picked evaluation via `?eval=<id>` so reload + share-link
 * both work.
 *
 * Linear: MYD-211 (E6).
 *
 * Note on the "Sidebar Scoring entry highlights" acceptance criterion: per
 * the user-locked sidebar IA (memory: feedback_sidebar_ia.md; canonical
 * implementation MYD-235), Scoring is NOT a sidebar entry. The route
 * `/scoring` remains valid and deep-linkable, but no sidebar item highlights
 * for it. The acceptance bullet is superseded by the IA lock — confirmed in
 * the Linear comment thread on this issue.
 */

import EvaluationModulePage from './_EvaluationModulePage'
import ScoringWorkspace from '../components/scoring/ScoringWorkspace'

const ScoringPage = () => (
	<EvaluationModulePage
		moduleName="Scoring"
		moduleDescription="Pick an evaluation to score sites against weighted criteria."
		workspacePhase="MYD-207 (E2)"
		workspaceHint="Three-pane workspace with criteria sidebar, score matrix, and weighted-rank visualisation."
		renderWorkspace={(evalId) => <ScoringWorkspace evalId={evalId} />}
	/>
)

export default ScoringPage
